export const API_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://deepgram-dot-deepprojectv3deploy.nw.r.appspot.com';

export const API_GET_TESTS = '/test';
export const API_GET_TESTS_BY_LANGUAGE = '/test/language/';
export const API_GET_TEST_BY_ID = '/test/';
export const API_CREATE_NEW_TEST = '/test';
export const API_UPDATE_TEST_BY_ID = '/test/';
export const API_REMOVE_TEST_BY_ID = '/test/';

export const API_LOGIN = '/auth/login';

export const API_GET_LANGUAGES = '/language';
export const API_CREATE_NEW_LANGUAGE = '/language';
export const API_UPDATE_LANGUAGE_BY_CODE = '/language/';
export const API_REMOVE_LANGUAGE_BY_CODE = '/language/';

export const API_GET_TYPEFORMS = '/typeform';
export const API_CREATE_NEW_TYPEFORM = '/typeform';
export const API_UPDATE_TYPEFORM_BY_ID = '/typeform/';
export const API_REMOVE_TYPEFORM_BY_ID = '/typeform/';

export const API_INSTAGRAM_SAVE = '/auth/instagram/';
export const API_INSTAGRAM_SEARCH = 'https://www.instagram.com/web/search/topsearch';
